const LEAVE_EVENTS = {
  LEAVE_OPEN: 'LEAVE:OPEN',
  LEAVE_CLOSE: 'LEAVE:CLOSE',
  LEAVE_TIMESHEET_SELECTION_CHANGED: 'LEAVE:TIMESHEET_SELECTION_CHANGED',
  UPDATE_LEAVE_POLICIES_DIALOG_SHOW: 'LEAVE:UPDATE_LEAVE_POLICIES_DIALOG:SHOW',
  LEAVE_MIGRATION_STARTED: 'LEAVE:MIGRATION_STARTED',
  LEAVE_BALANCE_BREAKDOWN_OPEN: 'LEAVE:BALANCE_BREAKDOWN:OPEN',
  LEAVE_BALANCE_BREAKDOWN_CLOSE: 'LEAVE:BALANCE_BREAKDOWN:CLOSE',
  LEAVE_BALANCE_BREAKDOWN_READY: 'LEAVE:BALANCE_BREAKDOWN:READY',
};

export default LEAVE_EVENTS;
